import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import V2Home from './V2Home';
import { V2About, V2Services, V2AreasPricing, V2Notary, V2FAQ, V2Contact } from './V2Pages';

export default function V2Routes() {
  return (
    <Routes>
      <Route path="/" element={<V2Home />} />
      <Route path="/about" element={<V2About />} />
      <Route path="/services" element={<V2Services />} />
      <Route path="/areas-pricing" element={<V2AreasPricing />} />
      <Route path="/areas-covered" element={<V2AreasPricing />} />
      <Route path="/notary" element={<V2Notary />} />
      <Route path="/faq" element={<V2FAQ />} />
      <Route path="/contact" element={<V2Contact />} />
      <Route path="*" element={<Navigate to="/v2" replace />} />
    </Routes>
  );
}
